import './CrossProductFilter.scss'

import { CloseOutlined } from '@ant-design/icons'
import { Button, Checkbox, InputNumber, Slider, Tag } from 'antd'
import CenteredLayout from 'components/centered-layout/CenteredLayout'
import React from 'react'

interface Props {
  categories: any
  selectedCategoryIds: number[]
  onCategoryChange: (newIds: number[]) => void
  markalar: any
  selectedMarkaIds: number[]
  onMarkaChange: (newIds: number[]) => void
  minPrice: number | null
  maxPrice: number | null
  setMinPrice: React.Dispatch<React.SetStateAction<number | null>>
  setMaxPrice: React.Dispatch<React.SetStateAction<number | null>>
  minTempPrice: number
  setMinTempPrice: React.Dispatch<React.SetStateAction<number>>
  maxTempPrice: number
  setMaxTempPrice: React.Dispatch<React.SetStateAction<number>>
  absoluteMin: number
  absoluteMax: number
}

const CrossProductFilterPage = ({
  categories,
  selectedCategoryIds,
  onCategoryChange,
  markalar,
  selectedMarkaIds,
  onMarkaChange,
  minPrice,
  maxPrice,
  setMinPrice,
  setMaxPrice,
  minTempPrice,
  setMinTempPrice,
  maxTempPrice,
  setMaxTempPrice,
  absoluteMin,
  absoluteMax,
}: Props) => {
  const handleCategoryChange = (category: any) => {
    const newIds = selectedCategoryIds.includes(category.id)
      ? selectedCategoryIds.filter((id) => id !== category.id)
      : [...selectedCategoryIds, category.id]
    onCategoryChange(newIds)
  }

  const handleMarkaChange = (markaId: number) => {
    const newIds = selectedMarkaIds.includes(markaId)
      ? selectedMarkaIds.filter((id) => id !== markaId)
      : [...selectedMarkaIds, markaId]
    onMarkaChange(newIds)
  }

  const handleRangeChange = (value: number[]) => {
    setMinTempPrice(value[0])
    setMaxTempPrice(value[1])
  }

  const handleSearch = () => {
    const isDefault = minTempPrice === absoluteMin && maxTempPrice === absoluteMax
    setMinPrice(isDefault ? null : minTempPrice)
    setMaxPrice(isDefault ? null : maxTempPrice)
  }

  const handleClearPrice = () => {
    setMinPrice(null)
    setMaxPrice(null)
    setMinTempPrice(absoluteMin)
    setMaxTempPrice(absoluteMax)
  }

  const priceFilterActive = minPrice !== null || maxPrice !== null

  const priceChipLabel = (() => {
    if (minPrice !== null && maxPrice !== null) return `${minPrice} ₺ – ${maxPrice} ₺`
    if (minPrice !== null) return `Min: ${minPrice} ₺`
    return `Max: ${maxPrice} ₺`
  })()

  return (
    <CenteredLayout>
      <div className="cross-products-filter">
        <div className="categories-filter filter">
          <h3 className="title">Kategoriler</h3>
          <div className="categories-map  filter-map">
            {categories.map((category: any) => (
              <div className="categories-content" key={category.id}>
                <Checkbox checked={selectedCategoryIds.includes(category.id)} onChange={() => handleCategoryChange(category)}>
                  <span className="category-title">{category.isim}</span>
                </Checkbox>
              </div>
            ))}
          </div>
        </div>
        {markalar.length > 0 && (
          <div className="brand-filter  filter">
            <h3 className="title">Markalar</h3>
            <div className="filter-map">
              {markalar.map((veriler: any, index: number) => (
                <div className="categories-content" key={index}>
                  <Checkbox checked={selectedMarkaIds.includes(veriler.id)} onChange={() => handleMarkaChange(veriler.id)}>
                    <span className="category-title"> {veriler.isim}</span>
                  </Checkbox>
                </div>
              ))}
            </div>
          </div>
        )}
        <div className="price-filter  filter">
          <h3 className="title">Fiyat Aralığı</h3>
          <div className="price-inputs">
            <Slider
              range
              min={absoluteMin}
              max={absoluteMax}
              step={1}
              value={[minTempPrice, maxTempPrice]}
              onChange={handleRangeChange}
              tooltip={{ formatter: (v) => `${v} ₺` }}
            />
            <div className="price-range-labels">
              <InputNumber
                min={absoluteMin}
                max={maxTempPrice}
                value={minTempPrice}
                onChange={(v) => handleRangeChange([v ?? absoluteMin, maxTempPrice])}
              />
              <span>–</span>
              <InputNumber
                min={minTempPrice}
                max={absoluteMax}
                value={maxTempPrice}
                onChange={(v) => handleRangeChange([minTempPrice, v ?? absoluteMax])}
              />
            </div>
            {priceFilterActive && (
              <Tag
                closable
                closeIcon={<CloseOutlined />}
                onClose={handleClearPrice}
                style={{
                  backgroundColor: 'var(--color-primary-light)',
                  borderColor: 'var(--color-primary)',
                  color: 'var(--color-primary)',
                }}
              >
                {priceChipLabel}
              </Tag>
            )}
            <Button type="primary" block onClick={handleSearch}>
              Ara
            </Button>
          </div>
        </div>
      </div>
    </CenteredLayout>
  )
}

export default CrossProductFilterPage
